import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Search,
  DeleteForever,
} from "@mui/icons-material";
import "devextreme/data/odata/store";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Card, Col, Container, Dropdown, Form, Modal, Pagination, Row, Table } from "react-bootstrap";
import * as yup from "yup";

import API from "../../api/api";
import { parsedUser } from "../../utils/GetCurrentUser";
import { useLocation, useParams } from "react-router-dom";
import { TextBox, DateBox } from "devextreme-react";
import FieldSelector from "../../components/customComponents/FieldSelector";
import { useFormik } from "formik";
import Sha256 from "../../utils/sha256";

import { useToast } from "../../contexts/toast";
import yupTypeValidator from "../../utils/YupTypeValidator";
import { exportToPDF as GeneratePDF } from '../../utils/export-to-pdf';
import { exportToExcel as GenerateXLS } from '../../utils/export-to-excel';
import { CustomBreadcrumbs as Breadcrumbs } from "../../components";
import CustomModal from "../../components/CustomModal/CustomModal";
import useFavorite from "../../hooks/useFavorite";
import { useApiResponseHandler } from "../../hooks/useApiResponseHandler";
import moment from "moment";
import "../../index.css";
import "../../styles/stickyTable.css";

// Componente personalizado para el botón de cerrar modal
const CustomCloseButton = ({ onClose }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      style={{
        border: "1px solid #b0b0b0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease",
        backgroundColor: isHovered ? "#ff4136" : "",
        cursor: "pointer"
      }}
      className="btn"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClose}
      aria-label="Close"
    >
      <i 
        style={{ 
          fontSize: "20px", 
          color: isHovered ? "#ffffff" : "#b0b0b0",
          transition: "color 0.2s ease"
        }} 
        className="fa-solid fa-xmark"
      ></i>
    </button>
  );
};

export default function CRUDSimple() {
  // PROPERTIES
  const user = parsedUser();
  const { pathname } = useLocation();
  const params = useParams();
  const { idModule } = useParams();
  const toast = useToast();

  const [recordCount, setRecordCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [generalError, setGeneralError] = useState(null);
  const [open, setOpen] = useState(false);
  const [actionMode, setActionMode] = useState(null);//I=Insert, U= Update = C= Consultar, D= Delete
  const [loading, setLoading] = useState(false);
  // const [isPinned, setIsPinned] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const checkAudit = localStorage.getItem('AuditInformation')
  const { handleApiResponse, ErrorModal } = useApiResponseHandler();

  const initialModel = {
    section: {},
    data: {
      Columns: [],
      Rows: [],
    },
  }
  const [section, setSection] = useState(null);
  const [fields, setFields] = useState([])
  const [model, setModel] = useState(initialModel);
  const [search, setSearch] = useState(""); // Búsqueda general (string simple)
  const [columnFilters, setColumnFilters] = useState({}); // Filtros por columna (objeto)
  const [openFilterColumn, setOpenFilterColumn] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [RecordsQuantity, setRecordsQuantity] = useState(10);
  const allowedPageSizes = [{ value: 10, text: 10 }, { value: 20, text: 20 }, { value: 50, text: 50 }, { value: 100, text: 100 }, { value: 0, text: "Todos" }];
  const [selectedItem, setSelectedItem] = useState(null);
  const { isPinned, UpdateFavorites, checkIfPinned } = useFavorite()
  const selectedItemRef = useRef(null);
  const [sortBy, setSortBy] = useState('Id')
  const [sortByOrder, setSortByOrder] = useState('DESC')
  const stickyHeaderRef = useRef(null);
  const [stickyHeaderHeight, setStickyHeaderHeight] = useState(0);
  
  // Estados para el modal de Auditoría de Cambios
  const [openAuditModal, setOpenAuditModal] = useState(false);
  const [auditStartDate, setAuditStartDate] = useState('');
  const [auditEndDate, setAuditEndDate] = useState('');
  const [auditData, setAuditData] = useState([]);
  const [auditHeaders, setAuditHeaders] = useState([]);
  const [loadingAudit, setLoadingAudit] = useState(false);
  
  // Filter helper functions
  const updateColumnFilter = (fieldName, value) => {
    setColumnFilters(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const clearAllFilters = async () => {
    setSearch("");
    setColumnFilters({});
    setOpenFilterColumn(null);
    setTimeout(async () => {
      await bindDataRemote(true);
      await bindDataCountRemote(true);
    }, 100);
  };

  const toggleFilterDropdown = (fieldName) => {
    setOpenFilterColumn(openFilterColumn === fieldName ? null : fieldName);
  };

  const applyColumnFilter = async () => {
    setOpenFilterColumn(null);
    await bindDataRemote();
    await bindDataCountRemote();
  };

  const clearSingleColumnFilter = async (fieldName) => {
    setColumnFilters(prev => {
      const newFilters = { ...prev };
      delete newFilters[fieldName];
      return newFilters;
    });
    setTimeout(async () => {
      await bindDataRemote();
      await bindDataCountRemote();
    }, 100);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openFilterColumn && !event.target.closest('.position-relative')) {
        setOpenFilterColumn(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openFilterColumn]);
  
  // Funciones para el modal de Auditoría de Cambios
  const toggleAuditModal = () => {
    if (openAuditModal) {
      // Al cerrar, limpiar datos
      setAuditStartDate('');
      setAuditEndDate('');
      setAuditData([]);
      setAuditHeaders([]);
    } else {
      // Al abrir, establecer fechas por defecto (último mes)
      const today = new Date();
      const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
      setAuditStartDate(lastMonth.toISOString().split('T')[0]);
      setAuditEndDate(today.toISOString().split('T')[0]);
    }
    setOpenAuditModal(!openAuditModal);
  };

  // Función preparada para obtener datos de auditoría (conectar cuando el endpoint esté listo)
  const getAuditData = async () => {
    try {
      setLoadingAudit(true);
      console.log("🔍 Consultando auditoría de cambios...");
      console.log("  - Fecha Inicio:", auditStartDate);
      console.log("  - Fecha Fin:", auditEndDate);
      console.log("  - Id Formulario:", params.id);
      
      // TODO: Conectar con el endpoint cuando esté listo
      // Ejemplo de la estructura esperada:
      // let prefix = idModule ? "CRUDDynamic" : "CRUD";
      // let query = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}&StartDate=${auditStartDate}&EndDate=${auditEndDate}${idModule ? "&IdModule=" + idModule : ""}`;
      // let request = await API.getAction(`api/${prefix}/AuditHistory`, query);
      
      // Por ahora, datos de ejemplo para la maquetación
      const mockHeaders = [
        { FieldName: "FechaModificacion", FieldTitle: "Fecha Modificación", Alignment: "center" },
        { FieldName: "Usuario", FieldTitle: "Usuario", Alignment: "left" },
        { FieldName: "Accion", FieldTitle: "Acción", Alignment: "center" },
        { FieldName: "Campo", FieldTitle: "Campo Modificado", Alignment: "left" },
        { FieldName: "ValorAnterior", FieldTitle: "Valor Anterior", Alignment: "left" },
        { FieldName: "ValorNuevo", FieldTitle: "Valor Nuevo", Alignment: "left" },
        { FieldName: "Registro", FieldTitle: "Registro", Alignment: "left" }
      ];
      
      const mockData = [
        {
          Id: 1,
          FechaModificacion: "03/01/2026 10:30:00",
          Usuario: "ADMIN",
          Accion: "Actualización",
          Campo: "Nombre",
          ValorAnterior: "Juan Pérez",
          ValorNuevo: "Juan Carlos Pérez",
          Registro: "REG-001"
        },
        {
          Id: 2,
          FechaModificacion: "02/01/2026 15:45:00",
          Usuario: "JDOE",
          Accion: "Creación",
          Campo: "N/A",
          ValorAnterior: "",
          ValorNuevo: "Nuevo Registro",
          Registro: "REG-002"
        },
        {
          Id: 3,
          FechaModificacion: "01/01/2026 09:15:00",
          Usuario: "ADMIN",
          Accion: "Eliminación",
          Campo: "N/A",
          ValorAnterior: "Registro Eliminado",
          ValorNuevo: "",
          Registro: "REG-003"
        }
      ];
      
      setAuditHeaders(mockHeaders);
      setAuditData(mockData);
      
      toast({
        type: "success",
        message: `Se encontraron ${mockData.length} registro(s) de auditoría`
      });
      
    } catch (error) {
      console.error("❌ Error al obtener auditoría:", error);
      toast({
        type: "error",
        message: "No se pudieron cargar los datos de auditoría"
      });
      setAuditData([]);
      setAuditHeaders([]);
    } finally {
      setLoadingAudit(false);
    }
  };

  // Función para exportar datos de auditoría a Excel
  const exportAuditToExcel = useCallback(() => {
    if (!auditData || auditData.length === 0) {
      toast({
        type: "warning",
        message: "No hay datos de auditoría para exportar"
      });
      return;
    }
    
    const excelData = auditData.map((item) => {
      return auditHeaders.reduce((acc, column) => {
        acc[column.FieldTitle] = item[column.FieldName];
        return acc;
      }, {});
    });
    
    GenerateXLS(excelData, `Auditoria_${section?.FormTitle}_${moment().format("YYYYMMDD")}.xlsx`);
    
    toast({
      type: "success",
      message: "Archivo exportado correctamente"
    });
  }, [auditData, auditHeaders, section]);
  
  // END PROPERTIES



  //METHODS
  ///BRING THE DATA FROM THE SERVER FOR MODEL AND RECORDS
  const bindDataRemote = useCallback(async (cleanFilter) => {

    // First start loading the model
    setLoading(true);

    //First load records

    try {
      let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      
      // Filtros por columna tienen prioridad sobre búsqueda general
      if (Object.keys(columnFilters).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(columnFilters));
      } else if (search.length > 0 && cleanFilter == null) {
        // Búsqueda general solo si no hay filtros de columna
        query += "&Search=" + search;
      }
      
      query += `&SortBy=${sortBy}&SortType=${sortByOrder}`;
      let quantity = RecordsQuantity === 0 ? recordCount : RecordsQuantity;
      query = query + `&Quantity=${quantity}&pageNumber=${currentPage}`
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let request = await API.getAction(`api/${prefix}/Records`, query);
      let results = request.data[0];
      let parsedResults = JSON.parse(results.JSONData)[0];

      let recordResult = parsedResults.JSONData || [];
      // let configInfo = recordResult[0].JSONConfig ? recordResult[0].JSONConfig[0] : null;
      let dataFromAPI = recordResult[0] ? (recordResult[0].JSONConfig ? recordResult[0].JSONData : recordResult) : [];
      console.log("Results from record", recordResult);


      //TODO: | Use JSONConfig to show specific fields
      let gridData = null;
      let gridColumns = dataFromAPI && dataFromAPI.length > 0 ? Object.keys(dataFromAPI[0]).filter(x => !x.startsWith("Id")) : null;

      //! If grid data stays null, we use the data from the API

      let titles = ['Audit Information', 'Added by', 'Date Added', 'Modified by', 'Last Modified']

      /*setModel({
        ...model,

        data: {
          ...model.data,
          Columns: gridColumns,
          Rows: gridData || dataFromAPI,
        },
      }); */
      //debugger;
      setModel({
        ...model,
        
        data: {
          ...model.data,
          Columns: gridColumns,
          Rows: dataFromAPI,
        },
      });



    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, search, columnFilters, sortBy, sortByOrder, RecordsQuantity, params.id, idModule]);


  useEffect(() => {
    setTableHeader([])
    bindDataRemote();
    setSelectedItem(null);
    bindDataCountRemote();
  }, [params.id, idModule])

  useEffect(() => {
    bindDataRemote();
    setSelectedItem(null);
  }, [currentPage])

  const bindDataCountRemote = async (cleanFilter) => {

    // First start loading the model
    //setLoading(true);

    //First load records

    try {
      let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      
      // Filtros por columna tienen prioridad sobre búsqueda general
      if (Object.keys(columnFilters).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(columnFilters));
      } else if (search.length > 0 && cleanFilter == null) {
        // Búsqueda general solo si no hay filtros de columna
        query += "&Search=" + search;
      }

      query = query + `&Quantity=${RecordsQuantity}&pageNumber=${currentPage}`
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let request = await API.getAction(`api/${prefix}/RecordsCount`, query);


      let results = request.data[0];
      let parsedResults = JSON.parse(results.JSONData)[0];
      setRecordCount(parsedResults.JSONData.Count);
      console.log("Record Count that comes from api ", parsedResults.JSONData.Count)


    } catch (error) {
      console.error(error);
    } finally {
      // setLoading(false);
    }
  };

  const bindDataModelRemote = async (cleanFilter) => {


    try {

      let prefix = idModule ? "CRUDDynamic" : "CRUD";

      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      let requestSections = await API.getAction(`api/${prefix}/Model`, querySections);
      let resultsSections = requestSections.data[0];
      let parsedResultsSections = JSON.parse(resultsSections.JSONData)[0];
      
      // Verificar si hay error, logout o sesión expirada
      if (parsedResultsSections) {
        if (handleApiResponse(parsedResultsSections)) {
          return;
        }
      }

      let recordResultSection = parsedResultsSections.JSONData;

      //! If grid data stays null, we use the data from the API

      let titles = ['Informacion de auditoria']
      console.log(recordResultSection)
      setSection(recordResultSection[0]);
      setFields(recordResultSection[0].Fields.filter((item) => !titles.includes(item.FieldTitle)));

    } catch (error) {
      console.error(error);
    } finally {
      //  setLoading(false);
    }
  };
  const [formSize, setFormSize] = useState('md');
  const [tableHeader, setTableHeader] = useState([]);
  useEffect(() => {

  })
  const bindDataHeaderRemote = async (cleanFilter) => {


    try {

      let prefix = idModule ? "CRUDDynamic" : "CRUD";

      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      let requestSections = await API.getAction(`api/${prefix}/Header`, querySections);
      console.log("Header", requestSections)
      let resultsSections = requestSections.data[0];
      let parsedResultsSections = JSON.parse(resultsSections.JSONData)[0];
      console.log("Header 2", parsedResultsSections)
      
      // Verificar si hay error, logout o sesión expirada
      if (parsedResultsSections) {
        if (handleApiResponse(parsedResultsSections)) {
          return;
        }
      }

      let recordResultSection = parsedResultsSections.JSONData;
      console.log(recordResultSection);
      setFormSize(recordResultSection[0].FormSize ?? 'md');

      //! If grid data stays null, we use the data from the API

      let titles = ['Informacion de auditoria']
      console.log(recordResultSection)

      setTableHeader(recordResultSection[0].Fields)

    } catch (error) {
      console.error(error);
    } finally {
      //  setLoading(false);
    }
  };

  useEffect(() => { bindDataRemote() }, [checkAudit])

  const bindDataDetailsRemote = async (recordId) => {
    //First load records
    try {
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}&RecordId=${recordId}${idModule ? "&IdModule=" + idModule : ""}`;
      let request = await API.getAction(`api/${prefix}/Details`, query);
      let results = request.data[0];

      let parsedResults = JSON.parse(results.JSONData)[0];
      
      // Verificar si hay error o logout
      if (parsedResults) {
        if (handleApiResponse(parsedResults)) {
          return;
        }
      }

      let finalResult = parsedResults.JSONData;
      fillFormikObject(finalResult);
      // setSelectedItem(null) // COMENTADO: Necesitamos mantener selectedItem para la navegación entre registros
    } catch (error) {
      console.error(error)
    }
    //Fill object with new values
  };

  //Open edit/add mode
  const toggleOpen = async (action, reload) => {
    setActionMode(action);

    if (action === null) {
      setSelectedItem(null);
      formik.resetForm();
    }

    if (action === "I") {
      setSelectedItem(null)
    }
    if (action === "U" || action === "C" || action === "D") {
      setOpen(!open);

      await bindDataDetailsRemote(selectedItem.GUID);
    }

    if (selectedItemRef.current) {
      selectedItemRef.current.clearSelection();
    }

    setGeneralError(null);
    setOpen(!open);
    if (reload) {
      bindDataRemote();
    }
  };

  // Función para navegar al registro anterior
  const navigateToPreviousRecord = async () => {
    const currentData = model?.data?.Rows || [];
    const currentIndex = currentData.findIndex(item => item.GUID === selectedItem?.GUID);
    
    if (currentIndex > 0) {
      const previousItem = currentData[currentIndex - 1];
      setSelectedItem(previousItem);
      
      // Llamar al endpoint para cargar los detalles del registro anterior
      if (previousItem.GUID) {
        await bindDataDetailsRemote(previousItem.GUID);
        console.log('⬅️ Navegando al registro anterior:', previousItem);
      }
    }
  };

  // Función para navegar al registro siguiente
  const navigateToNextRecord = async () => {
    const currentData = model?.data?.Rows || [];
    const currentIndex = currentData.findIndex(item => item.GUID === selectedItem?.GUID);
    
    if (currentIndex < currentData.length - 1) {
      const nextItem = currentData[currentIndex + 1];
      setSelectedItem(nextItem);
      
      // Llamar al endpoint para cargar los detalles del registro siguiente
      if (nextItem.GUID) {
        await bindDataDetailsRemote(nextItem.GUID);
        console.log('➡️ Navegando al registro siguiente:', nextItem);
      }
    }
  };

  // Función para verificar si hay registro anterior
  const hasPreviousRecord = () => {
    const currentData = model?.data?.Rows || [];
    const currentIndex = currentData.findIndex(item => item.GUID === selectedItem?.GUID);
    return currentIndex > 0;
  };

  // Función para verificar si hay registro siguiente
  const hasNextRecord = () => {
    const currentData = model?.data?.Rows || [];
    const currentIndex = currentData.findIndex(item => item.GUID === selectedItem?.GUID);
    return currentIndex >= 0 && currentIndex < currentData.length - 1;
  };

  //Delete the record
  const deleteConfirm = async (obj) => {
    const mensajeConfirmacion = "¿Confirma que desea eliminar este registro?";
    
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <CustomModal
            type="error"
            title="¡Confirmar Acción!"
            message={mensajeConfirmacion}
            icon="fa-trash-can"
            primaryButtonText="Continuar"
            secondaryButtonText="Cancelar"
            onPrimaryClick={async () => {
              // Enviar respuesta "Si" al backend con DialogText y DialogResp
              let prefix = idModule ? "CRUDDynamic" : "CRUD";
              let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}&RecordId=${selectedItem.GUID}${idModule ? "&IdModule=" + idModule : ""}&DialogText=${encodeURIComponent(mensajeConfirmacion)}&DialogResp=Si`;
              await API.getAction(`api/${prefix}/Delete`, query);
              await bindDataRemote();
              setSelectedItem(null);
              
              toast({
                type: "success",
                message: "Registro eliminado!",
                messageSecondary: "El registro ha sido eliminado correctamente"
              });
            }}
            onSecondaryClick={async () => {
              // Enviar respuesta "No" al backend con DialogText y DialogResp
              let prefix = idModule ? "CRUDDynamic" : "CRUD";
              let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}&RecordId=${selectedItem.GUID}${idModule ? "&IdModule=" + idModule : ""}&DialogText=${encodeURIComponent(mensajeConfirmacion)}&DialogResp=No`;
              await API.getAction(`api/${prefix}/Delete`, query);
            }}
            onClose={onClose}
          />
        );
      }
    });
  };

  //Update the field value on formik according to what has been updated
  const updateField = (fieldName, fieldValue) => {
    formik.setFieldValue(fieldName, fieldValue);
  };



  const [validationsSchema, setValidationSchema] = useState(null);

  const fillFormikObject = (record) => {
    //debugger;
    console.log("record", record, "model", section);
    if (
      section &&
      fields &&
      fields.length > 0
    ) {
      fields.forEach((item) => {
        console.log(
          "field name",
          item.FieldName,
          "RecordValue ",
          record[item.FieldName]
        );
        formik.setFieldValue(item.FieldName, record[item.FieldName]);
      });
    }

    //Now
  };

  const prepareFormikObject = () => {
    // console.log("Preparing formik object", section)
    let initialObject = {};
    let initialObjectValidation = {};

    if (fields) {
      fields.forEach((item) => {
        initialObject[item.FieldName] = item.value;

        if (item.Required) {
          initialObjectValidation[item.FieldName] = yupTypeValidator(item);
        }
      });
    }
    formik.initialValues = initialObject;

    console.log("initialObject", initialObject)

    setValidationSchema(yup.object(initialObjectValidation));
    //Now
  };

  //This method is to save the record we are working on
  const handleSubmit = async (obj, event) => {
    console.log("❗ ~ file: CRUDSimple.js:259 ~ handleSubmit ~ obj:", obj)
    console.log({ fields: fields })
    let actions = {
      "I": "I",
      "U": "U",
      "D": "I"
    };

    if (actionMode === "D") {
      const { GUID, Id, ...rest } = obj;
      obj = rest;
    }


    const mensajeConfirmacion = actionMode === "I" 
      ? "¿Confirma que desea guardar este registro?"
      : "¿Confirma que desea guardar los cambios realizados a este registro?";
    
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <CustomModal
            type={actionMode === "I" ? "info" : "warning"}
            title="¡Confirmar Acción!"
            message={mensajeConfirmacion}
            primaryButtonText="Confirmar"
            secondaryButtonText="Cancelar"
            onPrimaryClick={async () => {
              // Enviar respuesta "Si" al backend con DialogText y DialogResp
              let objSPVersion = "";
              
              // Si es modo UPDATE, agregar el GUID primero
              if (actionMode === "U" && obj.GUID) {
                objSPVersion = `@GUID='${obj.GUID}'`;
                console.log("✅ Agregando GUID para UPDATE:", obj.GUID);
              }
              
              fields.forEach((item) => {
                if (item.ReadOnly || item.HtmlType === "separator") return;
                // No incluir GUID nuevamente si ya se agregó
                if (item.FieldName === "GUID") return;

                if (item.HtmlType !== "separator") {
                  objSPVersion +=
                    (objSPVersion.length > 0 ? ", " : "") + `@${item.FieldName}=`;
                }
                if (
                  item.FieldType === "int" ||
                  item.FieldType === "bool" ||
                  item.FieldType === "bit" ||
                  item.FieldType === "bigint"
                ) {
                  objSPVersion +=
                    obj[item.FieldName] === undefined || obj[item.FieldName] === null
                      ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                      : "'" + obj[item.FieldName] + "'";
                } else if (item.HtmlType === "password") {
                  let passwordEncrypted = null;
                  if (obj[item.FieldName] && obj[item.FieldName].length > 0) {
                    passwordEncrypted =
                      obj["LoginName"].toUpperCase() + obj[item.FieldName];
                    passwordEncrypted = Sha256.hash(passwordEncrypted);
                  }
                  objSPVersion +=
                    obj[item.FieldName] === undefined
                      ? "null"
                      : "'" + passwordEncrypted + "'"
                } else if (item.HtmlType === 'radio') {
                  objSPVersion +=
                    obj[item.FieldName] === undefined || obj[item.FieldName] === null
                      ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                      : "'" + obj[item.FieldName] + "'";
                } else {
                  objSPVersion +=
                    obj[item.FieldName] === undefined || obj[item.FieldName] === null
                      ? "null"
                      : "'" + obj[item.FieldName] + "'";
                }
              });

              let queryString = `IdUser=${user.IdUser}&Id=${params.id}&Token=${user.Token}&ActionMode=${actions[actionMode]}${idModule ? "&IdModule=" + idModule : ""}&DialogText=${encodeURIComponent(mensajeConfirmacion)}&DialogResp=Si`;
              let queryData = {
                Data: objSPVersion,
              };

              let prefix = idModule ? "CRUDDynamic" : "CRUD";
              let request = await API.postAction(
                `api/${prefix}/AddEdit?${queryString}`,
                queryData
              );

              if (request.status === 200) {
                let response = JSON.parse(request.data[0].JSONData)[0];
                
                // Verificar si hay error, logout o sesión expirada
                if (response) {
                  if (handleApiResponse(response)) {
                    return;
                  }
                }
              }
              setGeneralError(null);
              setSelectedItem(null);

              formik.resetForm();

              toast({
                type: "success",
                "message": "¡Registro actualizado!",
                "messageSecondary": "El registro ha sido guardado correctamente"
              })
              toggleOpen(null, true);
            }}
            onSecondaryClick={async () => {
              // Enviar respuesta "No" al backend con DialogText y DialogResp
              // Preparar los datos para enviar
              let objSPVersion = "";
              
              // Si es modo UPDATE, agregar el GUID primero
              if (actionMode === "U" && obj.GUID) {
                objSPVersion = `@GUID='${obj.GUID}'`;
                console.log("✅ Agregando GUID para UPDATE:", obj.GUID);
              }
              
              fields.forEach((item) => {
                if (item.ReadOnly || item.HtmlType === "separator") return;
                // No incluir GUID nuevamente si ya se agregó
                if (item.FieldName === "GUID") return;

                if (item.HtmlType !== "separator") {
                  objSPVersion +=
                    (objSPVersion.length > 0 ? ", " : "") + `@${item.FieldName}=`;
                }
                if (
                  item.FieldType === "int" ||
                  item.FieldType === "bool" ||
                  item.FieldType === "bit" ||
                  item.FieldType === "bigint"
                ) {
                  objSPVersion +=
                    obj[item.FieldName] === undefined || obj[item.FieldName] === null
                      ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                      : "'" + obj[item.FieldName] + "'";
                } else if (item.HtmlType === "password") {
                  let passwordEncrypted = null;
                  if (obj[item.FieldName] && obj[item.FieldName].length > 0) {
                    passwordEncrypted =
                      obj["LoginName"].toUpperCase() + obj[item.FieldName];
                    passwordEncrypted = Sha256.hash(passwordEncrypted);
                  }
                  objSPVersion +=
                    obj[item.FieldName] === undefined
                      ? "null"
                      : "'" + passwordEncrypted + "'"
                } else if (item.HtmlType === 'radio') {
                  objSPVersion +=
                    obj[item.FieldName] === undefined || obj[item.FieldName] === null
                      ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                      : "'" + obj[item.FieldName] + "'";
                } else {
                  objSPVersion +=
                    obj[item.FieldName] === undefined || obj[item.FieldName] === null
                      ? "null"
                      : "'" + obj[item.FieldName] + "'";
                }
              });

              let queryString = `IdUser=${user.IdUser}&Id=${params.id}&Token=${user.Token}&ActionMode=${actions[actionMode]}${idModule ? "&IdModule=" + idModule : ""}&DialogText=${encodeURIComponent(mensajeConfirmacion)}&DialogResp=No`;
              let queryData = {
                Data: objSPVersion,
              };

              let prefix = idModule ? "CRUDDynamic" : "CRUD";
              await API.postAction(
                `api/${prefix}/AddEdit?${queryString}`,
                queryData
              );
            }}
            onClose={onClose}
          />
        );
      }
    });


  };

  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,

    validateOnChange: false,
    validateOnBlur: false,

    validationSchema: validationsSchema,
    onSubmit: handleSubmit,
  });


  const addFavorite = async () => {

    const newFavorite = {
      icon: `${section.FormIcon}`,
      path: pathname,
      formPath: section.FormPath,
      title: section.FormTitle,
    }
    UpdateFavorites(newFavorite)

  }

  const headerWithoutAuditFields = () => {
    return tableHeader && tableHeader
      .filter(x =>
        x.FieldTitle !== "Audit Information"
        && x.FieldName !== "Id"
        && x.FieldName !== "IdUserAdd"
        && x.FieldName !== 'DateAdd'
        && x.FieldName !== 'IdUserMod'
        && x.FieldName !== 'DateMod'
        
      
      )
  }

  // Modified by Frandy para exportar solo las columnas visibles
  const exportToExcel = useCallback(async () => {

    const visibleColumns = headerWithoutAuditFields();
    
    const excelData = model.data.Rows && model.data.Rows.map((item) => {
      return visibleColumns.reduce((acc, column) => {
        acc[column.FieldName] = item[column.FieldName];
        return acc;
      }, {});

    });
  
    GenerateXLS(excelData, `${section.FormTitle}.xlsx`);

  }, [model.data.Rows, tableHeader, section]);

  const exportToPDF = useCallback(async () => {
    const container = document.getElementById("contentContainer");
    if (container) {
      await GeneratePDF(container, "landscape", section?.FormTitle || "Registro");
    } else {
      console.error("No se encontró el contenedor para exportar a PDF");
      alert("Error: No se puede exportar el contenido. Elemento no encontrado.");
    }
    // GeneratePDF(container);
  }, [section])

  // Add by Victor: Agrega el handlePrint para imprimir el contenido de la pantalla
  const handlePrint = useCallback(() => {
    // Crear el HTML de la tabla
    const visibleColumns = headerWithoutAuditFields();
    
    const tableHTML = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>${section?.FormTitle || 'Tabla'}</title>
          <style>
            @media print {
              @page {
                margin: 1cm;
                size: landscape;
              }
              body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
            }
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            h4 {
              text-align: center;
              font-weight: bold;
              margin-bottom: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              border: 1px solid #000;
            }
            th {
              background-color: #6c757d;
              color: white;
              font-weight: bold;
              padding: 8px;
              border: 1px solid #000;
              text-align: center;
            }
            td {
              padding: 8px;
              border: 1px solid #000;
            }
            tr:nth-child(even) {
              background-color: #f2f2f2;
            }
          </style>
        </head>
        <body>
          <h4>${section?.FormTitle || 'Tabla'}</h4>
          <table>
            <thead>
              <tr>
                ${visibleColumns.map(column => `<th>${column.FieldTitle}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${model?.data?.Rows?.map((item) => {
                return `<tr>
                  ${visibleColumns.map((column) => {
                    let cellValue = '';
                    if (column.FieldType === "datetime" || column.FieldType === "date") {
                      cellValue = moment(item[column.FieldName]).format("MM/DD/YYYY");
                    } else if (typeof item[column.FieldName] === 'boolean') {
                      cellValue = item[column.FieldName] ? 'Sí' : 'No';
                    } else {
                      cellValue = item[column.FieldName] || '';
                    }
                    return `<td>${cellValue}</td>`;
                  }).join('')}
                </tr>`;
              }).join('') || ''}
            </tbody>
          </table>
        </body>
      </html>
    `;

    // Crear un iframe temporal oculto
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    // Escribir el contenido en el iframe
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(tableHTML);
    iframeDoc.close();

    // Esperar a que se cargue y luego imprimir
    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        
        // Remover el iframe después de imprimir
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      }, 250);
    };
  }, [model?.data?.Rows, section, headerWithoutAuditFields])

  // END METHODS

  // UI METHODS

  useEffect(() => {
    console.log("entro", new Date())
    bindDataRemote();
  }, [sortBy, sortByOrder])

  const loadGRIDUI = () => {
    const stickyTableOffset = Math.max(stickyHeaderHeight - 1, 0);
    return (
      <>
        {/* {isSearching && (
          <Card className="mb-4">
            <Card.Header className="w-full d-flex justify-content-between align-items-center">
              <Card.Title>Filtros</Card.Title>

              <button
                className="btn btn-secondary"
                title="Cerrar"
                type="button"
                onClick={() => { setIsSearching(false) }}
                style={{
                  "padding": "0px 8px",
                  "lineHeight": "23px"
                }}
              >
                <i style={{ fontSize: "10px" }} className="fa-solid fa-x"></i>
              </button>
            </Card.Header>
            <Form
              onSubmit={async (e) => {
                e.preventDefault();
                await bindDataRemote();
              }}
            >
              <Card.Body className="formBackground p-0">
                <Row>
                  <Col className={"col-12"}>
                    <TextBox
                      id={"search"}
                      mode={"text"}
                      value={search}
                      placeholder="Buscar por descripción"
                      onValueChanged={(e) => {
                        setSearch(e.value);
                      }}
                    />
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer className="text-end">
                <button
                  className="btn btn-sm btn-outline-secondary me-2"
                  type="button"
                  title="Limpiar"
                  onClick={clearAllFilters}
                >
                  <i className="fa-solid fa-filter-circle-xmark" style={{ fontSize: '14px' }}></i>
                </button>
                <button className="btn btn-sm btn-primary" title="Buscar" type="submit">
                  <Search />
                </button>
              </Card.Footer>
            </Form>
          </Card>
        )} */}

        <Container>
          <Row
            // className="mx-2"
          >
            <div className="crud-table-outer">
              <div
                className="crud-table-scroll"
                style={{
                  // Dentro del contenedor con scroll, el sticky del thead debe pegarse arriba del contenedor (top: 0)
                  // El header sticky superior ya está fuera del scroll y no debe influir aquí.
                  ['--crud-sticky-top']: `0px`,
                  borderRadius: '7px',
                }}
              >
            <Table hover size="xl" bordered className="crud-table border shadow-sm">
              <thead className="table-secondary crud-table-thead">
                <tr borderer className="border shadow-sm ">
                  {headerWithoutAuditFields()
                    .map((item, index) => {
                      const isFilterActive = columnFilters[item.FieldName] && columnFilters[item.FieldName].length > 0;
                      const isDropdownOpen = openFilterColumn === item.FieldName;
                      
                      return (
                        <th
                          key={index}
                          className={`fw-bold position-relative crud-table-th`}
                          style={{
                            zIndex: 30
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <span 
                              className="clickable"
                              onClick={() => {
                                setSortBy(item.FieldName);
                                if (item.FieldName === sortBy) {
                                  if (sortByOrder === 'ASC') {
                                    setSortByOrder('DESC')
                                  } else {
                                    setSortByOrder('ASC')
                                  }
                                } else {
                                  setSortByOrder('ASC')
                                }
                              }}
                            >
                              {item.FieldTitle} 
                              {sortBy === item.FieldName && sortByOrder === 'ASC' ? 
                                <i className="fas fa-sort-up ms-1"></i> : 
                                sortBy === item.FieldName && sortByOrder === 'DESC' ? 
                                <i className="fas fa-sort-down ms-1"></i> : null
                              }
                            </span>
                            
                            
                            <button
                              className={`btn btn-sm btn-link p-0 ms-2 ${isFilterActive ? 'text-primary' : ''}`}
                              title={`Filtrar por ${item.FieldTitle}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleFilterDropdown(item.FieldName);
                              }}
                            >
                            
                              <i className={`fa-solid ${isFilterActive ? 'fa-filter-circle-xmark' : 'fa-filter'}`}></i>
                              
                            </button>
                            
                          </div>
                          
                          {isDropdownOpen && (
                            <div 
                              className="position-absolute bg-white border rounded shadow-lg p-3" 
                              style={{
                                top: '-25px',
                                left: 0,
                                // encima del thead, pero sin competir con el header sticky superior / modales
                                zIndex: 10,
                                minWidth: '250px',
                                marginTop: '5px'
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div className="mb-2">
                                <label className="form-label small fw-bold">Filtrar por {item.FieldTitle}</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  placeholder={`Buscar ${item.FieldTitle}...`}
                                  value={columnFilters[item.FieldName] || ""}
                                  onChange={(e) => updateColumnFilter(item.FieldName, e.target.value)}
                                  onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                      applyColumnFilter();
                                    }
                                  }}
                                  autoFocus
                                />
                              </div>
                              <div className="d-flex justify-content-end gap-2">
                                <button
                                  className="btn btn-sm btn-outline-secondary"
                                  onClick={async () => {
                                    setSearch("");
                                    setColumnFilters({});
                                    setOpenFilterColumn(null);
                                    await bindDataRemote(true);
                                    await bindDataCountRemote(true);
                                  }}
                                >
                                  Limpiar
                                </button>
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={applyColumnFilter}
                                >
                                  Aplicar
                                </button>
                              </div>
                            </div>
                          )}
                        </th>
                      )
                    })}
                </tr>
              </thead>
              <tbody>
                {model?.data && model.data.Rows.map((item, index) => {

                  // console.log("item", item, "header", tableHeader);
                  return (
                    <tr key={index} onClick={() => { setSelectedItem(item) }} className={selectedItem && selectedItem.GUID === item.GUID ? "active" : ""}>
                      {headerWithoutAuditFields()
                        .map((column, index2) => {
                          if (column.FieldType === "datetime" || column.FieldType === "date") {
                            return (
                              <td key={index2} className={` `}>{moment(item[column.FieldName]).format("MM/DD/YYYY")}</td>
                            )
                          }

                          return (
                            <td key={index2} className={` `}>{
                              (typeof item[column.FieldName] === 'boolean') ? <input type="checkbox" checked={item[column.FieldName]} className="" readOnly /> : item[column.FieldName]
                            }</td>
                          )
                        })}
                    </tr>
                  )
                })}
              </tbody>
            </Table>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              {(model?.data?.Columns && model?.data?.Rows.length > 0) && (<div className="d-flex align-items-center gap-3">
                <p className="m-0 fw-bold">Total de registros:</p>
                <span 
                  className="badge d-flex align-items-center justify-content-center" 
                  style={{ 
                    fontSize: '0.875rem', 
                    height: '31px',
                    minWidth: '70px',
                    backgroundColor: '#ffffff', 
                    color: '#495057',
                    border: '1px solid #DFE2E6',
                    padding: '0.375rem 0.75rem',
                    borderRadius: '.25rem'
                  }}
                >
                  {recordCount.toLocaleString('en-US')}
                </span>
                <p className="m-0">Registros por página:</p>
                <div>
                  <select
                      className="form-select form-select-sm"
                      value={allowedPageSizes.find(item => item.value === RecordsQuantity)}
                      onChange={(e) => {
                        console.log("selected value", e.target.value)
                        if (e.target.value < 1) {
                          setRecordsQuantity(recordCount);
                        } else {
                          setRecordsQuantity(e.target.value)
                        }
                        setCurrentPage(1)
                      }}
                    >
                      {allowedPageSizes.map((item, index) => {
                        return (
                          <option key={index} value={item.value}>
                            {item.text}
                          </option>
                        );
                      }
                      )}
                    </select>
                </div>
              </div>)}
              {(model?.data?.Columns && model?.data?.Rows.length > 0) && (<Pagination className="my-0">
                <Pagination.First disabled={loading} onClick={() => setCurrentPage(1)} />
                <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage <= 1 || loading} />
                
                {/* Lógica de paginación dinámica - Muestra 5 páginas */}
                {(() => {
                  const pages = [];
                  let startPage, endPage;
                  
                  if (totalPages <= 5) {
                    // Si hay 5 páginas o menos, mostrar todas
                    startPage = 1;
                    endPage = totalPages;
                  } else {
                    // Si hay más de 5 páginas
                    if (currentPage <= 3) {
                      // Al inicio: mostrar 1, 2, 3, 4, 5
                      startPage = 1;
                      endPage = 5;
                    } else if (currentPage >= totalPages - 2) {
                      // Al final: mostrar las últimas 5
                      startPage = totalPages - 4;
                      endPage = totalPages;
                    } else {
                      // En el medio: mostrar 2 antes y 2 después de la actual
                      startPage = currentPage - 2;
                      endPage = currentPage + 2;
                    }
                  }
                  
                  // Mostrar ellipsis al inicio si es necesario
                  if (startPage > 1) {
                    pages.push(
                      <Pagination.Item 
                        key={1}
                        disabled={loading} 
                        active={false}
                        onClick={() => setCurrentPage(1)}
                      >
                        1
                      </Pagination.Item>
                    );
                    if (startPage > 2) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
                    }
                  }
                  
                  // Mostrar las páginas del rango
                  for (let i = startPage; i <= endPage; i++) {
                    pages.push(
                      <Pagination.Item 
                        key={i}
                        disabled={loading} 
                        active={currentPage === i}
                        onClick={() => setCurrentPage(i)}
                      >
                        {i}
                      </Pagination.Item>
                    );
                  }
                  
                  // Mostrar ellipsis al final si es necesario
                  if (endPage < totalPages) {
                    if (endPage < totalPages - 1) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
                    }
                    pages.push(
                      <Pagination.Item 
                        key={totalPages}
                        disabled={loading} 
                        active={false}
                        onClick={() => setCurrentPage(totalPages)}
                      >
                        {totalPages}
                      </Pagination.Item>
                    );
                  }
                  
                  return pages;
                })()}
                
                <Pagination.Next disabled={currentPage >= totalPages || loading} onClick={() => setCurrentPage(currentPage + 1)} />
                <Pagination.Last disabled={loading} onClick={() => setCurrentPage(totalPages)} />
              </Pagination>)}
            </div>
            {/* {console.log("Current Page", currentPage, "Total Pages", totalPages)} */}
          </Row>
        </Container>
      </>
    );
  };

  //EVENTS


  useEffect(() => {
    setOpen(false)
    setSelectedItem(null)
    setActionMode(null)
    setGeneralError(null)
    setModel(initialModel);
    checkIfPinned();
    setIsSearching(false);
    setSearch("");
    setColumnFilters({});
    bindDataModelRemote();
    bindDataHeaderRemote();
    setCurrentPage(1);
    //bindDataRemote();

    return () => formik.resetForm();
  }, [params.id]);

  useEffect(() => {

    console.log("section updated", model)
    prepareFormikObject();
  }, [section, fields]);
  // END EVENTS
  useEffect(() => {
    console.log("entro record quantity")
    bindDataRemote();
  }, [RecordsQuantity])

  useEffect(() => {
    console.log("Record Count", recordCount, "Records Quantity", RecordsQuantity);
    console.log("Pages", Math.ceil(recordCount / RecordsQuantity))
    setTotalPages(Math.ceil(recordCount / RecordsQuantity))
  }, [recordCount, RecordsQuantity])
  
  // Calcular la altura del header sticky para ajustar el top del thead
  useEffect(() => {
    const node = stickyHeaderRef.current;

    if (!node) {
      setStickyHeaderHeight(0);
      return;
    }

    const updateStickyHeight = () => {
      const height = node.offsetHeight || 0;
      setStickyHeaderHeight(height);
      console.log("📏 Altura del header sticky (CRUD):", height);
    };

    updateStickyHeight();

    const observer = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(updateStickyHeight)
      : null;

    if (observer) {
      observer.observe(node);
    }

    window.addEventListener('resize', updateStickyHeight);

    return () => {
      if (observer) {
        observer.disconnect();
      }
      window.removeEventListener('resize', updateStickyHeight);
    };
  }, [open, openAuditModal, isSearching, actionMode, loading, selectedItem, section, model?.data?.Rows?.length]);
  if (!section) {
    return <></>
  }
  return (
    <React.Fragment>
      {/* Contenedor sticky para breadcrumbs, título y botones */}
      <div 
        ref={stickyHeaderRef}
        style={{
          position: 'sticky',
          top: '0px',
          backgroundColor: '#F2F2F2',
          // Debe ganar a toda la grilla (thead/rows) pero quedar por debajo de los modales (bootstrap modal ~1050)
          zIndex: (open || openAuditModal) ? 1 : 1030,
          paddingBottom: '10px',
        }}
      >
        {section?.FormPath && <Breadcrumbs pathTitle={section?.FormPath} />}
        <Container>
          <div className="row mx-0">
            <div className="col-12">
              <div className="d-flex flex-wrap align-items-center justify-content-between mb-2 mt-2">
                <React.Fragment>
                  <div className="d-flex align-items-center my-1">
                    <i className={section.FormIcon + " me-3 fa-2x"}></i>
                    <div className="d-flex flex-column">
                      <h5 className={"my-1"}>{section.FormTitle}</h5>
                    </div>
                  </div>
                </React.Fragment>
                {/* {loading ? (
                  <React.Fragment>
                    <div className="">
                      <div className="w-25 mx-auto my-1" style={{ paddingTop: "" }}>
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Cargando...</span>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                ) : null} */}
                <div className="w-auto d-flex align-items-center">
                  {actionMode === null ? (
                    <>
                      <button className="btn btn-sm btn-primary my-1 me-2" title="Crear" disabled={loading} onClick={() => toggleOpen("I")}>
                        <i className="fa fa-plus"></i>
                      </button>
                      <button 
                        className="btn btn-sm my-1 me-2"
                        title="Actualizar" 
                        disabled={loading} 
                        onClick={async () => {
                          await bindDataRemote();
                          await bindDataCountRemote();
                        }}
                        style={{
                          backgroundColor: '#6c757d',
                          borderColor: '#6c757d',
                          color: '#fff'
                        }}
                      >
                        <i className="fa fa-sync"></i>
                      </button>
                      {/* {!isSearching && (
                        <button className={`btn btn-sm border border-secondary my-1 me-2`} title="Buscar" onClick={() => setIsSearching(true)}>
                          <i className="fa-thin fa-magnifying-glass"></i>
                        </button>
                      )} */}
                    </>
                  ) : null}
                  {selectedItem ? (
                    <>
                      <button className="btn btn-sm border border-secondary my-1 me-2" title="Actualizar" disabled={loading} onClick={() => toggleOpen("U")} aria>
                        <i className="fa-thin fa-pencil"></i>
                      </button>
                      <button className="btn btn-sm border border-secondary my-1 me-2" title="Ver" disabled={loading} onClick={() => toggleOpen("C")}>
                        <i className="fa-thin fa-eye"></i>
                      </button>
                    </>
                  ) : null}

                  <Dropdown>
                    <Dropdown.Toggle variant="button" id="dropdown-basic">
                      <i className="fa fa-ellipsis-v" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {isPinned ? 
                      <Dropdown.Item onClick={() => { addFavorite() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                        <div style={{ width: '40px', display: 'inline-block' }}>
                          <i className="fa-thin fa-bookmark-slash" style={{ fontSize: '1.2rem' }}></i>
                        </div>
                        Remover de favoritos
                      </Dropdown.Item> : 
                      <Dropdown.Item onClick={() => { addFavorite() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                        <div style={{ width: '40px', display: 'inline-block' }}>
                          <i className="fa-thin fa-bookmark" style={{ fontSize: '1.2rem' }}></i>
                        </div>
                        Agregar a favoritos
                      </Dropdown.Item>
                      }
                      <Dropdown.Divider />
                      {selectedItem ?
                        <Dropdown.Item onClick={() => { toggleOpen('D') }} style={{ fontWeight: 400, fontSize: '14px' }}>
                          <div style={{ width: '40px', display: 'inline-block' }}>
                            <i className="fa-thin fa-clone-plus" style={{ fontSize: '1.2rem' }}></i>
                          </div>
                          Duplicar
                        </Dropdown.Item> : null
                      }

                      {actionMode === null ?
                        <Dropdown.Item onClick={() => { exportToExcel() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                          <div style={{ width: '40px', display: 'inline-block' }}>
                            <i className="fa-thin fa-file-xls" style={{ fontSize: '1.2rem' }}></i>
                          </div>
                          Exportar a Excel
                        </Dropdown.Item> : null
                      }
                      
                        <Dropdown.Item
                          onClick={() => { exportToPDF() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                            <div style={{ width: '40px', display: 'inline-block' }}>
                              <i className="fa-thin fa-file-pdf" style={{ fontSize: '1.2rem' }}></i>
                            </div>
                            Exportar a PDF
                        </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => { handlePrint() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                          <div style={{ width: '40px', display: 'inline-block' }}>
                            <i className="fa-thin fa-print" style={{ fontSize: '1.2rem' }}></i>
                          </div>
                          Imprimir
                      </Dropdown.Item>

                      <Dropdown.Divider />

                      <Dropdown.Item
                        onClick={() => { toggleAuditModal() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                          <div style={{ width: '40px', display: 'inline-block' }}>
                            <i className="fa-thin fa-file-chart-column" style={{ fontSize: '1.2rem' }}></i>
                          </div>
                          Auditoría de Cambios
                      </Dropdown.Item>
                      
                      {selectedItem ?
                        <Dropdown.Item onClick={() => deleteConfirm()} style={{ fontWeight: 400, fontSize: '14px' }}>
                          <div style={{ width: '40px', display: 'inline-block' }}>
                            <i className="fa-thin fa-trash-can" style={{ fontSize: '1.2rem' }}></i>
                          </div>
                          Eliminar
                        </Dropdown.Item> : null
                      }
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>

      {open ?
        <Modal
          show={open}
          onHide={() => toggleOpen(null)}
          backdrop="static"
          keyboard={false}
          size={formSize}
          className={"modalRight " + formSize}
        >
          <Modal.Header style={{ backgroundColor: "#D7DEE5" }}>
            <Modal.Title className="d-flex align-items-center w-100">
              <span>{section.FormTitle}</span>
              
              {/* Botones de navegación - solo en modo Consultar */}
              {actionMode === "C" && selectedItem && model?.data?.Rows && (
                <div className="ms-auto d-flex gap-2 align-items-center me-4">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={navigateToPreviousRecord}
                    disabled={!hasPreviousRecord()}
                    title="Registro anterior"
                  >
                    <i className="fa fa-chevron-left"></i> Anterior
                  </button>
                  
                  <span className="d-flex align-items-center px-2 text-muted small">
                    {model.data.Rows.findIndex(item => item.GUID === selectedItem?.GUID) + 1} / {model.data.Rows.length}
                  </span>
                  
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={navigateToNextRecord}
                    disabled={!hasNextRecord()}
                    title="Registro siguiente"
                  >
                    Siguiente <i className="fa fa-chevron-right"></i>
                  </button>
                </div>
              )}
            </Modal.Title>
            <CustomCloseButton onClose={() => toggleOpen(null)} />
          </Modal.Header>
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Body>
              <Row>
                {/* CONTENT */}
                {
                  fields.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <Col
                          className={
                            item.cssClasss + (!item.Visible ? " d-none" : "")
                          }
                          key={index}
                        >
                          <label className={item.HtmlType === 'separator' ? `me-2 ${(index !== 0 ? "mt-4 pt-4" : "mt-2")}  separatorTitle` : "me-2 mt-3 "}>{item.FieldTitle}
                            {item.Required ? <i className="required-asterisk ms-1 text-danger">*</i> : null}
                          </label>
                          <br />

                          <FieldSelector
                            actionMode={actionMode}
                            model={item}
                            key={index}
                            obj={formik.values}
                            // limit longitudes
                            updateField={updateField}
                            value={formik.values[item.FieldName]}
                          ></FieldSelector>
                          {formik.errors[item.FieldName] ? (
                            <div className="invalid text-sm">
                              {formik.errors[item.FieldName]}
                            </div>
                          ) : null}
                        </Col>
                      </React.Fragment>
                    );
                  })}
              </Row>

              {/* Modified by Frandy para mostrar los errores de los campos */}

               {/*
              
                {Object.values(formik.errors).length > 0 && Object.values(formik.errors).map(item => {

                  return <Row className="invalid me-2 ">{item}</Row>
                })}
            
              */}


            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#D7DEE5" }}>
              <div className="d-flex gx-3 align-items-center justify-content-end">
                {Object.values(formik.errors).length > 0 && (
                  <span className="invalid me-2">
                    Por favor, verificar los errores en el formulario
                  </span>
                )}

                {generalError ? <span className="invalid me-2">
                  {generalError}
                </span> : null}
                {/* 
                    - Add by Victor: Agrega color verde al boton Guardar, rojo al de Cerrar y aumenta el tamaño de ambos.
                    - Add by Victor: Cuando se consulte un registro en ReadOnly se visualiza el botón Cerrar de color Azul.                   
                */}
                <button 
                  className={`btn ${actionMode === "C" ? "btn-primary" : "btn-cancel-hover"} me-2`} 
                  type="button" onClick={() => toggleOpen(null)} 
                  style={{ width: "155px", height: "40px" }}>
                  <i className="fa-thin fa-arrow-u-turn-up-left me-2"></i>
                  {actionMode === "C" ? "Cerrar" : "Cancelar"}</button>
                  {actionMode !== "C" && <button 
                    className="btn btn-success" 
                    type="button" 
                    onClick={() => [formik.submitForm()]} 
                    style={{ width: "155px", height: "40px" }}>
                    <i className="fa-thin fa-check me-2"></i>
                    Guardar
                </button>}
              </div>
            </Modal.Footer>
          </Form>
        </Modal> : null}
      
      {/* Modal de Auditoría de Cambios */}
      {openAuditModal && (
        <Modal
          show={openAuditModal}
          onHide={toggleAuditModal}
          backdrop="static"
          keyboard={false}
          dialogClassName="modal-fullwidth-custom"
          className="modalRight"
        >
          <Modal.Header style={{ backgroundColor: "#D7DEE5" }}>
            <Modal.Title>
              Auditoría de Cambios - {section?.FormTitle}
            </Modal.Title>
            <CustomCloseButton onClose={toggleAuditModal} />
          </Modal.Header>
          
          <Modal.Body>
            {/* Campos de rango de fechas */}
            <label className="me-2 mt-2 separatorTitle">Rango de Fechas</label>
            <br />
            <hr className="separatorLine" />
            
            <Row className="mb-3">
              <Col md={2}>
                <label className="me-2 mt-3">
                  Desde <span className="text-danger">*</span>
                </label>
                <DateBox
                  id="auditStartDate"
                  name="auditStartDate"
                  placeholder="Seleccione fecha inicio"
                  displayFormat="dd/MM/yyyy"
                  value={auditStartDate ? moment(auditStartDate).isValid() ? moment(auditStartDate).toDate() : null : null}
                  onValueChanged={(e) => {
                    const formattedDate = e.value ? moment(e.value).format('YYYY-MM-DD') : '';
                    setAuditStartDate(formattedDate);
                  }}
                />
              </Col>
              
              <Col md={2}>
                <label className="me-2 mt-3">
                  Hasta <span className="text-danger">*</span>
                </label>
                <DateBox
                  id="auditEndDate"
                  name="auditEndDate"
                  placeholder="Seleccione fecha fin"
                  displayFormat="dd/MM/yyyy"
                  value={auditEndDate ? moment(auditEndDate).isValid() ? moment(auditEndDate).toDate() : null : null}
                  onValueChanged={(e) => {
                    const formattedDate = e.value ? moment(e.value).format('YYYY-MM-DD') : '';
                    setAuditEndDate(formattedDate);
                  }}
                />
              </Col>
            </Row>

            {/* Tabla de resultados de auditoría */}
            <Row>
              <Col md={12}>
                <label className="me-2 mt-3 separatorTitle">
                  Resultados: {auditData.length > 0 ? auditData.length : 0} registro(s)
                </label>
                <br />
                <hr className="separatorLine" />
                
                <div style={{ 
                  maxHeight: 'calc(100vh - 450px)', 
                  minHeight: '300px',
                  overflowY: 'auto',
                  overflowX: 'auto', 
                  position: 'relative',
                  border: '1px solid #dee2e6',
                  borderRadius: '0.25rem'
                }}>
                  <Table hover bordered className="shadow-sm" size="sm" style={{ position: 'relative', marginBottom: 0 }}>
                    <thead className="table-secondary" style={{ 
                      position: 'sticky', 
                      top: 0, 
                      zIndex: 1,
                      backgroundColor: '#e9ecef',
                    }}>
                      <tr>
                        {auditHeaders.length > 0 ? (
                          auditHeaders.map((header, index) => (
                            <th 
                              key={index} 
                              className={header.Alignment === 'center' ? 'text-center' : ''}
                              style={{ textAlign: header.Alignment || 'left' }}
                            >
                              {header.FieldTitle}
                            </th>
                          ))
                        ) : (
                          <th className="text-center">No hay columnas disponibles</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {loadingAudit ? (
                        <tr>
                          <td colSpan={auditHeaders.length || 1} className="text-center py-4">
                            <div className="spinner-border spinner-border-sm me-2" role="status">
                              <span className="visually-hidden">Cargando...</span>
                            </div>
                            Cargando datos de auditoría...
                          </td>
                        </tr>
                      ) : auditData.length === 0 ? (
                        <tr>
                          <td colSpan={auditHeaders.length || 1} className="text-center text-muted py-4">
                            No hay registros de auditoría. Utilice el botón "Consultar" para buscar datos.
                          </td>
                        </tr>
                      ) : (
                        auditData.map((item, index) => (
                          <tr key={item.Id || index}>
                            {auditHeaders.map((header, colIndex) => (
                              <td 
                                key={colIndex}
                                className={header.Alignment === 'center' ? 'text-center' : ''}
                                style={{ textAlign: header.Alignment || 'left' }}
                              >
                                {item[header.FieldName]}
                              </td>
                            ))}
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </Modal.Body>
          
          <Modal.Footer style={{ backgroundColor: "#D7DEE5" }}>
            <div className="d-flex w-100 justify-content-between align-items-center">
              <div>
                {auditData.length > 0 && (
                  <button
                    className="btn btn-success"
                    type="button"
                    onClick={exportAuditToExcel}
                    disabled={loadingAudit}
                    style={{ width: "155px", height: "40px" }}
                  >
                    <i className="fa-thin fa-file-xls me-2"></i>
                    Exportar Excel
                  </button>
                )}
              </div>
              
              <div className="d-flex gx-3 align-items-center">
                <button  
                  className='btn btn-cancel-hover me-2' 
                  type="button" 
                  onClick={toggleAuditModal} 
                  style={{ width: "155px", height: "40px" }}>
                  <i className="fa-thin fa-arrow-u-turn-up-left me-2"></i>
                  Cancelar
                </button>
                
                <button 
                  className="btn btn-primary" 
                  type="button" 
                  disabled={!auditStartDate || !auditEndDate || loadingAudit}
                  onClick={getAuditData}
                  style={{ width: "155px", height: "40px" }}
                >
                  {loadingAudit ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Consultando...
                    </>
                  ) : (
                    <>
                      <i className="fa-thin fa-magnifying-glass me-2"></i>
                      Consultar
                    </>
                  )}
                </button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      
      <Container>
        <div className="row mx-0">
          <div className="col-12">
            {loadGRIDUI()}
          </div>
        </div>
      </Container>

      <style>{`
        /* Asegurar que los elementos sticky funcionen correctamente */
        html, body {
          overflow-x: hidden;
          position: relative;
        }
      `}</style>

      {/* Modal de error de la API */}
      <ErrorModal />
    </React.Fragment>
  );
}

// Estilos CSS personalizados para el botón de cerrar del modal
const styleElement = document.createElement('style');
styleElement.textContent = `
  .modal-header .btn-close {
    border: 1px solid #6c757d !important;
    border-radius: 0.25rem !important;
    padding: 0.5rem !important;
    opacity: 1 !important;
    background-color: white !important;

  }
  
  .modal-header .btn-close:hover {
    background-color: #6c757d !important;
    border-color: #6c757d !important;
  }
  
  .modal-header .btn-close:hover::before,
  .modal-header .btn-close:hover::after {
    background-color: white !important;
  }
`;
if (typeof document !== 'undefined' && !document.getElementById('modal-close-button-styles')) {
  styleElement.id = 'modal-close-button-styles';
  document.head.appendChild(styleElement);
}

